import { Maybe } from 'maybeasy';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { findLink } from '../../../../../../LinkyLinky';
import { Link as LinkT } from '../../../../../../Resource/Types';
import { T } from '../../../../../../Translations';
import CollaboratorAccessStore from '../../CollaboratorAccess/Store';

export interface Props {
  collaboratorAccessStore: CollaboratorAccessStore;
  links: ReadonlyArray<LinkT>;
}

// Item-level gate: the card resource emits manage-collaborator-access only
// when this admin may change the collection's permission type (owner, super
// admin, or ExecOnline org) — independent of Builder v1/v2 access.
export const collaboratorAccessLink = ({
  collaboratorAccessStore,
  links,
}: Props): Maybe<React.ReactNode> =>
  findLink('manage-collaborator-access', links).map((link) => (
    <Link
      key="manage-collaborator-access"
      to={'#'}
      onClick={() => collaboratorAccessStore.open(link)}
      className="px-4 py-2.5"
      data-intercom-target="collaborator-access-action"
    >
      <T kind="Manage Collaborator Access" />
    </Link>
  ));
